import ProductCover from './ProductCover'

export default ProductCover
